import React, { Suspense } from 'react';

import useLayout from '@context/layout/useLayout';

import StockBuySell from '@screens/StockBuySell/StockBuySell';
import { styTradePanel } from './style';

const TradePanel = () => {
  const { rightPanel, tradePanel } = useLayout();

  const styProps = {
    isRightPanelVisible: rightPanel.isVisible,
    isTradePanelVisible: tradePanel.isVisible,
  };

  return (
    <div className={styTradePanel(styProps)}>
      <Suspense fallback={null}>
        <StockBuySell />
      </Suspense>
    </div>
  );
};

export default TradePanel;
